import React from "react"
import { LinkLayout } from "../../../../../../Shared/Frontend/utils/links"
import { SharedBlockLayout } from "../../../modernBlocks/blocks/shared/sharedBlock.layout"
import { ParsedOverviewDetailItem } from "../widgets/overviewWidget.state"
import i18next from "i18next"

export const NewsOverviewLayout = {
    Wrap: (props: { children?: React.ReactNode; }): JSX.Element => {
        return (
            <section className="block block--news">
                <div className="block__layout">
                    <div className="block__inner ls-container ls-gutter ls-spacing">
                        <div className="block__content">
                            {props.children}
                        </div>
                    </div>
                </div>
            </section>
        )
    },
}

export function renderNewsOverviewItems(items: Immutable.List<ParsedOverviewDetailItem>): JSX.Element {
    return (
        <div className="block__teasers teasers">
            <ul className="teasers__list">
                {items.map((item, index) => {
                    const publishedDate = new Date(item.LastUpdated)
                    return (
                        <li className="teasers__item" key={`tn-${index}`}>
                            <article className="teaser teaser--news">
                                <LinkLayout
                                    link={{
                                        url: item.Link ? item.Link.url : '',
                                        title: item.Link ? item.Link.title : item.Title,
                                        target: '_self',
                                        kind: 'link'
                                    }}
                                    className="teaser__link"
                                >
                                    <div className="teaser__inner">
                                        <div className="teaser__content">
                                            {/* TODO: USE ACTUAL DATE */}
                                            <time dateTime={publishedDate.toISOString()} className="teaser__meta">{publishedDate.toLocaleString("nl-NL", {day: 'numeric', month: 'long', year: 'numeric'})}</time>
                                            <h2 className="teaser__title title--s">{item.Title}</h2>
                                        </div>

                                        <div className="teaser__visual">
                                            <SharedBlockLayout.ModernImageSrcSet
                                                image={item.image}
                                                lazyload={true}
                                                priority={undefined}
                                                classNames="teaser__image"
                                                imageProportions={{
                                                    width: '310',
                                                    height: '206',
                                                    sizes: '(min-width: 768px) 310px, 30vw'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </LinkLayout>
                            </article>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}